<template>
  <portal to="next-activity-button">
    <div class="nextSection">
      <next-activity-button :onClick="handleOnActivitySubmit" />
      <WrongIcon class="feedbackIcon" v-if="displayWrongIcon" :width="25" :height="40" />
      <CorrectIcon class="feedbackIcon" :width="35" :height="40" v-if="displayCorrectIcon" />
    </div>
  </portal>
</template>

<script>
import NextActivityButton from './NextActivityButton.vue';
import WrongIcon from '../icons/RedXSolidIcon.vue';
import CorrectIcon from '../icons/SuccessCheckSolidIcon.vue';

export default {
  name: 'activity-next-section-portal',
  components: {
    NextActivityButton,
    WrongIcon,
    CorrectIcon
  },
  props: {
    displayWrongIcon: {
      type: Boolean
    },
    displayCorrectIcon: {
      type: Boolean
    },
    handleOnActivitySubmit: {
      type: Function,
      default: () => null
    }
  }
};
</script>

<style lang="scss" scoped>
.nextSection {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .feedbackIcon {
    margin-top: 30px;
  }
}
</style>
